import styled, { css } from "styled-components";
import { ButtonStyledComponent } from "../button/button.style";

export const MenuOptionContainer = styled.div`
   background-color: #fff;
   position: absolute;
   min-width: 150px;
   z-index: 90;
   padding: 2rem 0;
   box-shadow: 0 3px 10px rgb(0 0 0 / 15%);
   top: 50px;
   left: ${({ left }) => left};
   opacity: 0;
   visibility: hidden;
   transition: top 150ms ease-out 100ms;
   color: ${({ theme }) => theme.colors?.grey};

   ${ButtonStyledComponent} & {
      background-color: ${({ theme }) => theme.colors?.white};
      font-weight: 400;
   }

   ${({ visible, top }) =>
      visible &&
      css`
         top: ${top};
         opacity: 1;
         visibility: visible;
      `}

   .option {
      width: 100%;
      padding: 7px 2rem;
      font-size: 1.4rem;
      font-weight: 500;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 1rem;
      color: ${({ theme }) => theme.colors?.grey};

      &:not(:last-child) {
         border-bottom: 1px solid #4371bf14;
      }

      &.blacklist-option:hover {
         background-color: rgba(228, 3, 59, 0.1);
         color: ${({ theme }) => theme.colors?.buttonRed};;
      }
      &.activate-option:hover {
         background-color: rgba(57, 205, 98, 0.1);
         color: ${({ theme }) => theme.colors?.green};;
      }

      &:hover {
         color: ${({ theme }) => theme.colors?.white};;
         font-weight: 500;
         background-color: ${({ theme }) => theme.colors?.grey};
      }
   }
`;
